<template>
  <v-container fluid no-padding class="home-hero" style="">
    <div class="video-wrapper">
      <video
        controls
        autoplay
        src="../assets/upload-2020-teaser.mp4"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      ></video>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Video',
  data() {}
};
</script>

<style scoped>
.home-hero {
  padding: 0;
}
video {
  width: 100%;
}
</style>
